import React, {Fragment} from "react";
const axios = require('axios');

import IconSearch from "./IconSearch";
import ProductRowPC from "./ProductRowPC";
import ProductULMobile from "./ProductULMobile";
import dispatchEvent from "../../components/dispatchEvent";
import {EVENT_ON_ORDER_UPDATE} from "../consts";
import addOrRemoveFromCart from "../addOrRemoveFromCart";

export default class ProductItems extends React.Component
{

    constructor(props) {
        super(props);

        this.state = {
            dirty: false,
            searching: false,
            keywords: '',
            results: []
        }

        this.updateKeywords = this.updateKeywords.bind(this);
        this.triggerSearch = this.triggerSearch.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.addToCart = this.addToCart.bind(this);
        this.setErrorTimer = this.setErrorTimer.bind(this);
        this.loadResults = this.loadResults.bind(this);
    }

    componentDidMount() {
        this.loadResults();
    }

    urlBase()
    {
        return this.props.link;
    }

    updateKeywords(e)
    {
        this.setState({
            keywords: e.target.value
        });
    }

    clearFilters(e)
    {
        e.preventDefault();
        this.setState({
            keywords: '',
            errors: '',
        }, () => {
            this.loadResults();
        });
        return false;
    }

    triggerSearch(e)
    {
        e.preventDefault();
        this.setState({
            dirty: true,
            searching: true
        });
        this.loadResults();
        return false;
    }

    loadResults()
    {
        axios.get('products-api', {
            params: {
                keywords: this.state.keywords,
                group: this.props.group
            }
        }).then((response) => {
            this.setState({
                results: response.data,
                searching: false
            });
        })
    }

    addToCart(id, quantity)
    {
        addOrRemoveFromCart(id, quantity);
    }

    setErrorTimer()
    {
        window.setTimeout(() => {
            this.setState({
                errors: ''
            })
        }, 7000);
    }

    render() {
        return <Fragment>
            <div className="order-page__search">
                <form onSubmit={this.triggerSearch}>
                    <input type="text" placeholder="Search on Product Code, Product Name" name="search"
                           value={this.state.keywords}
                           onChange={this.updateKeywords} />
                    <button type="submit">
                        <IconSearch />
                    </button>
                </form>
                {this.state.keywords != '' && <span className="btn btn--white--border order-page__search-clear" onClick={this.clearFilters}>Clear results</span>}
            </div>

            {!!this.state.searching && <p>Please wait.</p>}
            {!!(this.state.dirty && this.state.results.length === 0) && <p>No results.</p>}

            {this.state.results.length > 0 && <Fragment>

                <div className="order-page__table">
                    <div className="order-list">
                        {this.state.results.map((product) => {
                            return <ProductULMobile product={product}
                                                    key={`mobile_product_${product.id}`}
                                                    addToCart={this.addToCart} />
                        })}
                    </div>
                    <div className="content order-table">
                        <table>
                            <tbody>
                                <tr>
                                    <td>Product code</td>
                                    <td>Product Name</td>
                                    <td>Qty. Available</td>
                                    <td>Price</td>
                                    <td>Add to cart</td>
                                </tr>
                                {this.state.results.map((product) => {
                                    return <ProductRowPC product={product}
                                                         addToCart={this.addToCart}
                                                         key={`pc_product_${product.id}`} />
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

            </Fragment>}


        </Fragment>
    }


}
